import { TransformWrapper } from 'src/app/modules/design/transforms/transform.wrapper';
import { TNode } from '../models/domain/tnode';
import { DesignWrapper } from 'src/app/modules/design/design.wrapper';
import { DatabaseWrapper } from '../databases/database.wrapper';
import { CommonEnums } from '../common.enums';
import { JobWrapper } from 'src/app/modules/stream/jobs/job.wrapper';
import { StreamWrapper } from 'src/app/modules/stream/stream.wrapper';
import { EditorInputObj } from '../models/objs/editorinputobj';
import { ValidateObj } from '../models/objs/validateObj';
import { Obj_Db_Property } from '../models/datapoint/obj_db_property';
import { ErrorCdsEnums } from '../errorcds.enums';
import { LabelValueObj } from '../beans/labelvalueobj';
import { Usr_Log } from '../models/usr_log';
import { Design } from '../models/domain/design';
//import { DIMsgObj } from '../models/domain/dimsgobj';
import { DIMsgObj } from '../models/dimsgobj';
import { ObjectWrapperUtil } from '../utils/object.wrapper.util';
import { Attribute } from '../models/domain/attribute';
import { CanvasComment } from '../models/domain/canvas-comment';
import { CanvasCommentWrapper } from 'src/app/modules/design/transforms/canvascomment/canvascomment.wrapper';
import { StreamCanvasCommentWrapper } from 'src/app/modules/stream/jobs/canvascomment/streamcanvascomment.wrapper';
import { DObj } from '../models/domain/dobj';


export class ObjectWrapper {
    object: any;
    objectCopy: any;
    usr_Log: Usr_Log;
    gridObject: any;

    lockByMsg: string;
    _databaseWrapper: DatabaseWrapper;
    dObj:DObj;

    dataSubFlowWrapper: DesignWrapper;
    parentObjectWrapper: DesignWrapper;
    /** parentObj_Id default value is -2, and -1 means parent object is deleted. */
    parentObj_Id: number;
    parentFldr_Id: number;
    parentUrl: string;

    isScopeEnd: boolean;

    tabIndex: number;
    subTabIndex: number;

    designCanvasCommentWrapers: Array<CanvasCommentWrapper>;
    jobflowCanvasComments: Array<StreamCanvasCommentWrapper>;
    tabCodes: Array<string>;
    loadedTabs: Array<string>;
   
    inList: Array<any>;
    outList: Array<any>;
    showInList: boolean;
    showOutList: boolean;
    showScriptTab: boolean;
    showDataTab: boolean;
    showMonitorTab: boolean;

    panelTab: number;

    sub_Ids: Map<number, any>;
    subNames: Array<string>;
    deletedProjectParams: Array<any>;
    lookupLinkedGridList: Array<any>;
    editorInputObj: EditorInputObj;
    validateObj: ValidateObj;

    dependencyLevel: number;

    private _valid_Cd: string;
    showDescription: boolean;
    public get valid_Cd(): string {
        return this._valid_Cd;
    }
    public set valid_Cd(value: string) {
        this._valid_Cd = value;
    }
    valid_Msg: string;
    inValid_Cds: Array<string>;
    mode_IndMsg: string;

    imageUrl: string;
    url: string;
    width: number;
    height: number;
    expanded: boolean;
    isSelected: boolean;
    tabs: Array<any>;

    inLinkCount: number;
    outLinkCount: number;

    disableFlg: string;

    isShell: boolean;
    globalLabel: string;
    fldr_Cd: string;
    dBName: string;

    shortName: string;
    maxWidth: number;
    maxHeight: number;

    links: Array<any>;
    transformWrappers: Array<TransformWrapper>;
    // expandedObjectWrappers: Array<TransformWrapper>;
    expandedObjectWrappers: Array<any>;
    jobWrappers: Array<JobWrapper>;

    isCanvasNode: boolean;
    tNode: TNode;
    tNodesMap: Map<number, TNode>;
    nameTSpan1: string;
    nameTSpan2: string;
    dobjNmTspan: string;

    offsetX: number;
    offsetY: number;

    xPosition: number;
    yPosition: number;

    canvasWidth: number;
    canvasHeight: number;

    attributesHeight: number;

    updateBy: string;
    updateDt: Date;
    formattedUpdateDt: string;

    subRestParamsNames: Array<string>;
    subRestHeadersNames: Array<string>;
    subTwitterSearchTermsNames: Array<string>;
    subKafkaFilterColumnNames: Array<string>;

    subRestParameterNames: Array<string>;
    subFiltersNames: Array<string>;

    subOptionClauseNames: Array<string>;

    databaseNms: Array<string>;
    subMetaDataPropertiesNames: Array<string>;

    designWrapper: DesignWrapper;
    streamWrapper: StreamWrapper;

    carryForwardAttributes: Array<any>;
    carryForwardGroupAttributes: Array<any>;
    carryForwardAttributesNamesList: Array<any>;
    carryForwardAttributesHMapIds: Map<any, Attribute>;
    carryForwardAttributeObjectsHMapIds: Map<any, Attribute>;
    inputSubObjectsHMap_Ids: Array<any>;
    outPutAttributesHMapIds: Array<any>;
    maskingStratagy: any;

    carryForwardParams: Array<any>;
    carryForwardParamsNamesList: Array<any>;

    outPutAttributes: Array<any>;
    streamJobs: Array<any>;

    _conn_DbNms: Array<string>;
    maxLength: number;
    // name: string;
    selectedTabCode: string;

    scriptData: string;
    scriptError_Msg: string;

    dataError_Msg: string;
    dataWarning_Msg: string;
    hideDataTabIndex: number;
    dataTabIndex: number;
    rowCount: number;
    columnCount: number;
    hideDataStatus: boolean;
    isCanvasModified: boolean;
    // isCanvasItemPositionChanged: boolean;
    labelValueObjs: Array<LabelValueObj>;

    run_Id: number;
    debugRun_Id: number;
    isTransform: boolean;
    isJob: boolean;

    lookupLinkedList: Array<any>;
    showTransforms: boolean;
    showExprEditorDataObjects: boolean;
    showFunctions: boolean;
    showSequences: boolean;
    showExpressions: boolean;
    showUdfs: boolean;
    showRuntimeStatus: boolean;
    showRuntimeStatistics: boolean;

    disableKafkaFilterColumns: boolean;

    constructor() {
        this.disableKafkaFilterColumns = false;
        this.scriptData = "";
        this.scriptError_Msg = "";

        this.lockByMsg = "";

        this.dataError_Msg = "";
        this.dataWarning_Msg = "";
        this.hideDataTabIndex = -1;
        this.dataTabIndex = -1;
        this.rowCount = -1;
        this.columnCount = -1;
        this.hideDataStatus = false;

        this.dependencyLevel = 0;

        this.parentObj_Id = -2;
        this.parentFldr_Id = -1;
        this.parentUrl = "";

        this.sub_Ids = new Map<number, any>();
        this.subNames = new Array<string>();
        this.deletedProjectParams = new Array<any>();
        this.designCanvasCommentWrapers = new Array<CanvasCommentWrapper>();
        this.jobflowCanvasComments = new Array<StreamCanvasCommentWrapper>();

        this.tabIndex = 0;
        this.subTabIndex = -1;

        this.isScopeEnd = false;

        this.panelTab = 0;

        this.links = new Array<any>();

        this.labelValueObjs = new Array<LabelValueObj>();

        let ascLabelValueobj = new LabelValueObj();
        ascLabelValueobj.id = 1;
        ascLabelValueobj.label = 'ASC';
        ascLabelValueobj.value = 'A';
        this.labelValueObjs.push(ascLabelValueobj);

        let dscLabelValueobj = new LabelValueObj();
        dscLabelValueobj.id = 1;
        dscLabelValueobj.label = 'DSC';
        dscLabelValueobj.value = 'D';
        this.labelValueObjs.push(dscLabelValueobj);

        this.valid_Msg = '';
        this.inValid_Cds = new Array<string>();
        this.mode_IndMsg = '';

        this.canvasWidth = 0;
        this.canvasHeight = 0;
        this.attributesHeight = 0;

        this.subRestParamsNames = new Array<string>();
        this.subRestHeadersNames = new Array<string>();
        this.subTwitterSearchTermsNames = new Array<string>();
        this.subKafkaFilterColumnNames = new Array<string>();
        this.subOptionClauseNames = new Array<string>();
        this.subRestParameterNames = new Array<string>();
        this.subFiltersNames = new Array<string>();

        this.databaseNms = new Array<string>();
        this.subMetaDataPropertiesNames = new Array<string>();

        this.loadedTabs = new Array<string>();
        this.tabs = new Array<any>();
        this.tabCodes = new Array<string>();
        this.inList = new Array<any>();
        this.outList = new Array<any>();
        this.streamJobs = new Array<any>();
        this.showInList = false;
        this.showOutList = false;

        this.isCanvasNode = false;
        this.tNode = new TNode();

        this.nameTSpan1 = "";
        this.nameTSpan2 = "";
        this.dobjNmTspan = '';

        this.offsetX = 0;
        this.offsetY = 0;

        this._conn_DbNms = new Array<string>();

        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.url = CommonEnums.defaults.STRING_EMPTY;

        this.updateBy = '';
        this.updateDt = new Date();

        this.carryForwardAttributes = Array<any>();
        this.carryForwardAttributesNamesList = Array<any>();
        this.carryForwardAttributesHMapIds = new Map<any, Attribute>();
        this.carryForwardAttributeObjectsHMapIds = new Map<any, Attribute>();
        this.carryForwardGroupAttributes = new Array<any>();
        this.carryForwardParams = new Array<any>();
        this.carryForwardParamsNamesList = new Array<any>();
        this.inputSubObjectsHMap_Ids = new Array<any>();
        this.outPutAttributesHMapIds = new Array<any>();

        this.outPutAttributes = new Array<any>();
        this.jobWrappers = new Array<JobWrapper>();
        this.lookupLinkedGridList = new Array<any>();

        this.outLinkCount = 1;
        this.inLinkCount = 1;

        this.tNodesMap = new Map<number, TNode>();

        this.run_Id = -1;
        this.debugRun_Id = -1;

        this.isTransform = false;
        this.isJob = false;

        this.lookupLinkedList = new Array<any>();
        this.showTransforms = false;
        this.showExprEditorDataObjects = false;
        this.showFunctions = false;
        this.showUdfs = false;
        this.showSequences = false;
        this.showExpressions = false;
        this.showRuntimeStatus = false;
        this.showRuntimeStatistics = false;
        this.showScriptTab = true;
        this.showDataTab = true;
        this.showMonitorTab = true;
    }

    setDefaults(): void {
        this.valid_Msg = "";
        this.inValid_Cds.splice(0, this.inValid_Cds.length);

        if (this.valid_Cd != "0") {
            this.valid_Msg = ErrorCdsEnums.errorcds[this.valid_Cd];
            this.inValid_Cds.push(this.valid_Cd);
        }

        this.setLockByMsg();
    }

    setLockByMsg(): void {
        this.lockByMsg = "";
        if (this.mode_Ind != CommonEnums.mode_Ind.WRITE) {
            // this.lockByMsg = SessionFactory.getInstance().hasStudioViewPrivilege ?
            //     "Insufficient privileges to edit, Object opened in read mode" : "Object opened in read mode";

            this.lockByMsg = this.object.error_Msg;

            if (this.lockBy != "") {
                this.lockByMsg += ".";
                // this.lockByMsg += ", locked by " + this.lockBy;
            }


        }
    }

    get obj_Id(): number { return -1; }
    get obj_Cd(): string { return ''; }
    get objectName(): string { return ''; }
    get code(): string { return ''; }
    get dbTyp_Id(): number { return -1; }
    get name(): string { return ''; }
    set name(value: string) { }
    set conn_Id(value: number) { }
    get conn_Id(): number { return -1; }
    set conn_Db_Id(value: number) { }
    get conn_Db_Id(): number { return -1; }
    get nativeDbTyp_Id(): number { return -1; }
    get fldr_Id(): number { return -1; }
    get reusableFlag(): string { return CommonEnums.reusableFlag.NO; }
    get streamingFlg(): string { return CommonEnums.streamingFlg.NO; }
    get unlock_Ind(): string { return CommonEnums.flag.NO; }
    get mode_Ind(): string { return CommonEnums.mode_Ind.WRITE; }
    get lockBy(): string { return ""; }
    get change_Ind(): string { return CommonEnums.change_Ind.NO_CHANGE; }
    get change_Inda(): string { return CommonEnums.change_Ind.CHANGED; }
    get aliasName(): string { return CommonEnums.defaults.STRING_EMPTY; }
    get layer_Id(): number { return -1; }
    set aliasNm(value: string) { }
    get aliasNm(): string { return ""; }
    get looper_Id(): number { return -1; }

    doValidate(): void { };
    setChange_Ind(): void { }
    setChange_Inda(): void { }
    updateObject(object: any): void { }
    setUpdateDt(): void { }
    setUpdateBy(login: String) { }
    resetSrt_OrdersRestHaderProperties() { }
    resetSrt_OrdersSearchTermProperties() { }
    resetSrt_OrdersFilterColumns() { }
    resetSrt_OrdersOptionClauseProperties() { }
    resetSrt_OrdersRestParameters() { }
    setParamNm(paramValue: string) { }
    showOutlinkArrow(obj_Id: number, grp_Id: number) { }
    renameAttributes(value: string, replaceRegExp: any, replaceWith: string, oldFullName: string = '') { }

    //transform
    getInList() { return new Array<any>(); }
    revertAllExtractProperties(extract_Properties: Array<Obj_Db_Property>): void { }
    revertAllLoadProperties(loadProperties: Array<Obj_Db_Property>): void { }
    getAdditionalCarryForwardAttributes(srt_Order: number): void { };
    isTabDataModified(tabCode: string): any { };
    prepareSubObjects(): void { };
    prepareUploadedTabData(tabCode: string, onlyTransform: boolean = false): Design { return null };
    getAdditionalCarryForwardParameters(paramTyp, srt_Order): Array<any> { return [] };
    packCarryForwardGroupAttributes(): void {
        this.carryForwardGroupAttributes.splice(0, this.carryForwardGroupAttributes.length);

        for (let i: number = 0; i < this.carryForwardAttributes.length; i++) {
            let transformObject = this.carryForwardAttributes[i];

            for (let j: number = 0; j < transformObject.items.length; j++) {
                let item = transformObject.items[j];
                /*if( transformObject.obj_Cd == 'DOBJIS' &&
                        transformObject.dbTyp_Id == 30 && 
                        !item.showUnderline ) continue;*/

                this.carryForwardGroupAttributes.push(item)
            }
        }
    }
    getTransformWrapper(transform_Id: number): any { }
    get conn_DbNms(): Array<string> {
        return this._conn_DbNms;
    }

    getSub_Ids(): Map<number, any> {
        return this.sub_Ids;
    }

    getSubNames(): Array<string> {
        return this.subNames;
    }

    resetLoadedTab(): void {
        this.tabIndex = 0;
        this.panelTab = 0;
        this.selectedTabCode = "GEN";

        this.loadedTabs.splice(0, this.loadedTabs.length);
        this.loadedTabs.push('GEN');

        this.sub_Ids.clear();
        this.subNames.splice(0, this.subNames.length);

        ObjectWrapperUtil.getInstance().clearCarryForwardAttributes(this);

       // this.resetTabOpenedStatus();
       // this.resetTabData();
    }

    getAttributesLengthList(): Array<any> { return [] };
    orderByChanged(any): void { }
    partitionflagChanged(any): void { }
    distKeyFlagChanged(any): void { }
    getDistKeyFlagList(): Array<any> { return [] };
    resetTabOpenedStatus(): void { }
    resetTabData(): void { }
    copyTabData(transform: any, tabCode: string, onlyGeneralData: boolean = false) { }

    isNameExists(name: string, obj_Id: number = -1): boolean { return false; }

    get databaseWrapper(): DatabaseWrapper {
        return this._databaseWrapper;
    }

    set databaseWrapper(value: DatabaseWrapper) {
        this._databaseWrapper = value;
    }

    get dxMp_Id(): number {
        return -1;
    }

    deSelectAll(): void { }

    requiredInLinks(transformWrapper: ObjectWrapper): boolean {
        if (transformWrapper.inLinkCount == -1)
            return true;

        let inLinkCount = 0;
        for (let i = 0; i < transformWrapper.designWrapper.design.dxMp_Fwd_Lnks.length; i++) {
            if (transformWrapper.designWrapper.design.dxMp_Fwd_Lnks[i].fwd_Lnk_Obj_Id == transformWrapper.obj_Id) {
                inLinkCount++;
            }
        }

        if (inLinkCount < transformWrapper.inLinkCount)
            return true;
        else
            return false;
    }

    requiredOutLinks(grp_Id: number): boolean { return true; }
    canCreateOutLink(): boolean { return true }
    setNameTSpans(): void {
        if (this.obj_Cd == CommonEnums.codes.SOURCE ||
            this.obj_Cd == CommonEnums.codes.TARGET) {
            this.dobjNmTspan = this.object.dataObject.dObj.nm;
        }

        if (this.name.length <= 18) {
            this.nameTSpan1 = this.name;
            this.nameTSpan2 = "";
            return;
        }

        this.nameTSpan1 = this.name.slice(0, 18);

        if (this.name.length <= 33) {
            this.nameTSpan2 = this.name.slice(18, this.name.length);
            return;
        }

        this.nameTSpan2 = this.name.slice(18, 33) + "...";
    }

    get format() {
        return '';
    }

    get parentMode(): string {
        return CommonEnums.mode.EDIT;
    }
    set parentMode(mode_Ind: string) {};


    // createLink( objectWrapper, mouseOverObjectWrapper, grp_Id, fwd_Lnk_Grp_Id, mouseOverInList ): string {
    //     return '';
    // }

    get debugFlg(): string { return CommonEnums.flag.NO }

    inLinkCreated(link: any, fromJobWrapper: ObjectWrapper): void { }
    outLinkCreated(link: any, toJobWrapper: ObjectWrapper): void { }
    loopStartValidate(): void { }
    createLink(fromObjectWrapper: ObjectWrapper, toObjectWrapper: ObjectWrapper,
        grp_Id: number, fwd_Lnk_Obj_Id: number, mouseOverInList): DIMsgObj {
        return new DIMsgObj();
    }

    setFwd_Lnk_Grp_Id(dxMp_Fwd_Lnk, fromTransformWrapper, fwd_Lnk_Grp_Id, mouseOverInList): void { }

    packVenn_Grp_AttrsList(): void { }
    getPreceedingCarryForwardAttributes(fwd_Lnk_Obj_Id: number, fwd_Lnk_Grp_Id: number = -1): Array<any> { return new Array<any>(); }
}